<template>
  <v-app style="background:#eee;">
    <v-app-bar color="blue-grey" dense dark app>
      <v-app-bar-nav-icon @click.stop="userSelectBoxVis = !userSelectBoxVis"></v-app-bar-nav-icon>
      <v-toolbar-title style="font-size:1rem;width:95%;padding-left:0.4rem;">
        <span style="width:100%;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;display:inline-block;margin-top:0.56rem;">车辆测速
          <span v-if="staffInfo.STAFF_NAME"> - {{staffInfo.STAFF_NAME}}</span>
        </span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <!-- <v-icon>mdi-dots-vertical</v-icon> -->
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-list style="padding:0;">
          <v-list-item @click="goInvite" class="us-list-item">
            <v-list-item-title class="us-list-item-title">
              <i class="fa fa-paper-plane" />
              <span>邀请新用户</span>
            </v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="goScanQrcode" class="us-list-item">
            <v-list-item-title class="us-list-item-title">
              <v-icon>mdi-qrcode-scan</v-icon>
              <span>扫一扫</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-content>
      <v-container>
        <FollowPublicAccount v-if="followVis" />
        <StatCamImageCount v-if="!loading" />
        <div style="margin:1rem 0;"></div>
        <DeviceNotifyStat v-if="!loading" />
        <div style="margin:1rem 0;"></div>
        <DeviceNotifyList v-if="!loading" />
        <!-- <div style="margin:1rem 0;"></div>
        <DeviceList v-if="!loading" /> -->
        <div style="margin-bottom:6rem;margin-top:0.8rem;"></div>
        <UserSelectBox v-if="!loading" :visible.sync="userSelectBoxVis" @user-toggled="userToggled" />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import wx from 'weixin-js-sdk'
import StatCamImageCount from './components/StatCamImageCount'
// import DeviceList from './components/DeviceList'
import DeviceNotifyList from './components/DeviceNotifyList'
// import DeviceNotifyStat from './components/DeviceNotifyStat'
import DeviceNotifyStat from '../Biz/Notify/components/DeviceNotifyStat.vue'
import FollowPublicAccount from './components/FollowPublicAccount'
import UserSelectBox from '@/components/UserSelectBox'
export default {
  name: 'Home',
  components: {
    StatCamImageCount,
    // DeviceList,
    DeviceNotifyList,
    DeviceNotifyStat,
    FollowPublicAccount,
    UserSelectBox
  },
  data: () => ({
    companyInfo: {},
    loading: true,
    userInfo: {},
    followVis: false,
    userSelectBoxVis: false,
    staffInfo: {}
  }),
  methods: {
    init() {
      var that = this
      // that.$store.commit('SET_FNAVVAL', 0)
      that.loading = true
      that.$nextTick(function() {
        that.$AppHelper.pullUserCustomData(function(data) {
          // console.log(data)
          that.staffInfo = data.staff_info;
          that.userInfo = data.user_info;
          that.getFollowPublicAccount()
          that.loading = false
        });
      })
    },
    // 切换用户成功事件
    userToggled(code) {
      var that = this
      if (!code) {
        return
      }
      that.loading = true
      that.$nextTick(function() {
        that.staffInfo = that.$AppHelper.getCustomData('staff_info');
        that.loading = false
      })
    },
    // 是否管理员权限
    hasPermission() {
      var that = this
      if (that.staffInfo.STAFF_ROLE !== 'admin') {
        that.$toast.warning('只有管理员才可以操作');
        return false
      }
      return true
    },
    // 邀请新用户
    async goInvite() {
      var that = this
      if (!that.hasPermission()) {
        return
      }
      var expiry = 30
      var res = await that.$api.bz.createUserInvite({ user_code: that.staffInfo.USER_CODE, invite_expiry: expiry, s_role: 'common' })
      // // console.log('生成用户邀请码', res)
      if (!res.success) {
        // that.$toast.error('生成用户邀请码失败')
        console.log('生成用户邀请码失败', res);
        that.$toast.warning('生成邀请二维码失败');
        return
      }
      var data = res.data
      var query = { code: that.staffInfo.USER_CODE, name: that.staffInfo.USER_NAME, qrcode: data, expiry: expiry }
      that.$router.goPage({ path: '/UserInvite', query: query })
    },
    // 扫一扫二维码
    goScanQrcode() {
      const that = this
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: async function(res) {
          const result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          if (result === '') {
            that.$toast.warning('二维码不能为空')
            return
          }
          if (result.substring(0, 4) === 'http') {
            window.location.href = result
            return
          }
          that.$toast.success(result);
        }
      })
    },
    // 获取微信公众号关注情况
    async getFollowPublicAccount() {
      var that = this
      var userInfo = that.$AppHelper.getCustomData('user_info');
      var res = await that.$api.gzh.getFollowPublicAccount({ openid: userInfo.openid })

      if (!res.success) {
        console.log('获取微信公众号关注情况出错了', res)
        return
      }

      if (res.data === false) {
        that.followVis = true
      }
    }
  },
  created() {
  },
  mounted() {
    var that = this
    that.init()
  },
  activated() {
    var that = this
    that.$store.commit('SET_FNAVVAL', 0)
    if (!that.$router.isBack) {
      window.scroll(0, 0);
    }
  },
  deactivated() {
  }
}

</script>

<style scoped>
.us-create-btn{
  position:fixed;
  bottom: 4.5rem;
  right: 1.5rem;

}
</style>
